// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"503":"672f8ed3","774":"68db89c3","787":"0cc594f6","857":"09867317","858":"1e55827c","883":"93c68804"}[chunkId] + ".chunk.js";
};